<template>
  <div class="container" v-on:mouseover="changeWidth()" v-on:mouseleave="changeWidth()" :class="{'hoveredAlbum' : hover}">
    <img :src="albumCover" >
    <div v-if="hover" class="overlay">
      <h1>{{title}}</h1>
      <h2>By {{artist}}</h2>
      <h3>{{releaseDate}}</h3>
      <p>Favorite Song : {{favoriteSong}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlbumCard",
  props:["title","artist","favoriteSong","releaseDate","albumCover"],
  methods:{
    changeWidth(){
      this.hover = !this.hover;
    },
  },
  data(){
    return{
      hover:false,
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
}
.container{
  transition: all 0.3s ease;
}
img{
  width: 275px;
}
.hoveredAlbum{
  transform: scale(1.2);
}
h1{
  color: wheat;
}
h3{
  color: antiquewhite;
}
.overlay{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  padding: 20px;
  font-size: 16px;
  display: none;
  text-align: center;
  pointer-events: none; /* Allows click-through to the image */
}
.container:hover .overlay{
  display: block;
}

</style>